<template>
  <div class="alert">
    <audio
      v-if="notices"
      :autoplay="closeAlarmVideo || !total ? false : 'autoplay'"
      loop
      src="./alarm/tip.mp3"
      id="alarmVideo"
    ></audio>
    <img
      :src="closeAlarmVideo ? hornStop : horn"
      alt="警告"
      @click="changeVoice"
    />
    <div class="alert-content" v-show="!closeAlarmVideo">
      <div class="alert-content-detail" v-if="!total">暂无报警信息</div>
      <div v-else class="alert-content-detail" @click="show = true">
        <!--        【{{ notice.level }} & {{ notice.category }} & {{ notice.event }}】-->
        <!--        <span>{{ notice.name }}</span-->
        <!--        >：<span class="font-bold" style="color: red">{{ notice.value }}</span>-->

        <!--        <div v-for="n in events" :key="n.level" style="cursor: pointer">-->
        <!--          {{ n.name }}(-->
        <!--          <span>{{ n.amount }}</span>-->
        <!--          ) &nbsp;-->
        <!--        </div>-->
        <div class="alert-block">
          <ul :class="{ 'margin-top': animate }">
            <li
              v-for="(notice, index) in notices"
              :key="index"
              v-html="notice"
            ></li>
          </ul>
        </div>
      </div>
    </div>

    <sz-modal v-model="show" title="实时报警" height="100vh" width="100vw" :showRadio="false">
      <div class="c-notice" v-if="total">
        <!--        <el-row>-->
        <!--          <el-col-->
        <!--            :span="24"-->
        <!--            class="c-notice__title"-->
        <!--            :class="`c-notice--${notice.alarmType}`"-->
        <!--            >{{ notice.type }}-->
        <!--          </el-col>-->
        <!--        </el-row>-->
        <table class="item__header">
          <tr>
            <td class="name">最近报警</td>
            <td class="name">区域</td>
            <td class="name">站点</td>
            <td class="name">类型</td>
            <td class="name">报警值</td>
            <td class="name">持续时间（小时）</td>
            <td class="name">处理状态</td>
            <td class="name">工单操作</td>
          </tr>
          <tr v-for="item in events" :key="item.id">
            <td class="value">
              {{ item.last?new Date(item.last * 1000).Format("MM-DD hh:mm"):'' }}
            </td>
            <td class="value">
              {{ (item.o_alarm_sensor.o_station.o_area || {}).name }}
            </td>
            <td class="value">{{ item.o_alarm_sensor.o_station.name }}</td>
            <td class="value">{{ item.o_alarm_sensor.o_alarm.name }}</td>
            <td class="value">{{ item.value }}</td>
            <td class="value">{{ item.duration }}</td>
            <td class="value">
<!--              <event_comfirm-->
<!--                :row="item"-->
<!--                action="/rhenium/upload"-->
<!--                @success="onSuccess"-->
<!--              ></event_comfirm>-->
            </td>
            <td class="name" style="color: #2d8cf0">
              <span style="margin-right: 10px" @click="onPosition(item)">定位</span>
              <span @click="onAdd(item)">派单</span>
<!--              <span v-if="item.o_ticket" @click="onShowDetail(item)"-->
<!--                >工单详情</span-->
<!--              >-->
<!--              <span v-else @click="onAdd(item)">创建工单</span>-->
            </td>
          </tr>
        </table>
      </div>
    </sz-modal>
    <ticketCreate ref="ticketcreate" @on-success="onSuccess"></ticketCreate>
<!--    <Modal-->
<!--      v-model="ticketdetaildialog"-->
<!--      footer-hide-->
<!--      class="f-modal"-->
<!--      title="工单详情"-->
<!--      fullscreen-->
<!--    >-->
<!--      <ticket-detail-->
<!--        :viewer="true"-->
<!--        v-if="ticketdetaildialog"-->
<!--        :id="(selectRow.o_ticket || {}).id"-->
<!--      ></ticket-detail>-->
<!--    </Modal>-->
  </div>
</template>

<script>
import Vue from "vue";
import SzModal from "@/components/szModal.vue";
// import Tag from "graphql-tag";
// import event_comfirm from "@/components/alert/modules/event_comfirm.vue";
import {getValueUnit} from "@/utils";
import ticketCreate from "./modules/ticket_create.vue";
// import ticketDetail from "@/components/ticket/ticketDetail.vue";
const rep =[  {
  "sensorId": "671202fa9d75c1000174d985",
  "id": "6926a01feccc9800010447d7",
  "oid": "6926a01feccc9800010447d7",
  "first": 1764138917,
  "last": 1764245160,
  "recover": 0,
  "lvalue": 0.1,
  "status": -1,
  "rtime": 0,
  "rvalue": null,
  "conclusion": null,
  "cphoto": null,
  "comment": null,
  "ctime": null,
  "o_cuser": null,
  "o_puser": {
    "name": "管理员",
    "__typename": "User"
  },
  "result": null,
  "ptime": 1764139061,
  "pphoto": null,
  "pmark": null,
  "trigger": 1770,
  "ref": null,
  "exid": null,
  "extime": null,
  "exuid": null,
  "exsn": null,
  "o_exuser": null,
  "o_alarm_sensor": {
    "o_source": {
      "name": "管网压力",
      "unit": "P04",
      "o_realtime": {
        "value": -0.0078125,
        "time": 1764245160,
        "__typename": "RValue"
      },
      "__typename": "Sensor"
    },
    "o_alarm": {
      "name": "压力报警",
      "category": "business",
      "level": "alarm",
      "expression": "### < 1 ||  ### >= 3.2",
      "type": 1,
      "__typename": "Alarm"
    },
    "o_sensor": {
      "name": "报警",
      "__typename": "Sensor"
    },
    "o_station": {
      "id": "cs01",
      "name": "春申路DN300",
      "type": "monitor",
      "addr": null,
      "position": "114.14135,30.33454",
      "area": "66c611c77848f9000192fb29",
      "o_area": {
        "name": "五里界",
        "id": "6229a8af133ced00013a3732",
        "__typename": "Area"
      },
      "__typename": "Station"
    },
    "station": "65efd0986e20a90001a8f292",
    "device": "66c9ed9080a5a600019a2a96",
    "sensor": "671202fa9d75c1000174d985",
    "__typename": "AlarmSensor"
  },
  "o_ticket": null,
  "o_biz_command": null,
  "__typename": "Event",
  value:0.1
}];
export default {
  name: "Alert",
  components: { SzModal, ticketCreate},
  data() {
    return {
      stypes: ["factory", "dma"],
      ticketdetaildialog: false,
      timer: null,
      total: 0,
      events: [],
      horn: require("@/assets/icon/horn.png"),
      hornStop: require("@/assets/icon/horn-stop.png"),
      animate: 0,
      notices: [],
      closeAlarmVideo: true,
      show: false,
      level: {
        L1: "提示",
        L2: "警告",
        L3: "报警",
      },
      category: {
        X1: "设备",
        X2: "水量",
        X3: "业务",
        X4: "水压",
        X5: "水质",
        X6: "厂站",
      },
      selectRow: {},
      domain: process.env.VUE_APP_SERVER,
    };
  },
  methods: {
    changeVoice() {
      if (this.closeAlarmVideo && this.total) {
        this.closeAlarmVideo = !this.closeAlarmVideo;
        document.getElementById("alarmVideo").play();
        // this.$ls.set(
        //   "closeAlarmVideo",
        //   false,
        //   new Date().valueOf() + 3600 * 24000
        // );
      } else {
        this.closeAlarmVideo = !this.closeAlarmVideo;
        document.getElementById("alarmVideo").pause();
        // this.$ls.set(
        //   "closeAlarmVideo",
        //   true,
        //   new Date().valueOf() + 3600 * 24000
        // );
      }
      this.init()
      this.$emit('on-change-mn',this.closeAlarmVideo)
    },
    initVoice() {
      if (this.events) {
        if (this.closeAlarmVideo || !this.total) {
          document.getElementById("alarmVideo").pause();
        } else if (this.total) {
          document.getElementById("alarmVideo").play();
        }
      }
    },
    onAdd(row) {
      this.$refs.ticketcreate.addTicket(row);
    },
    onPosition(row){
      this.show = false;
      this.$emit('on-position',((row.o_alarm_sensor || {}).o_station || {}).id)
    },
    onShowDetail(row) {
      this.selectRow = row;
      this.ticketdetaildialog = true;
    },
    onSuccess() {
      this.init();
    },
    async init() {
//       this.$apollo
//         .query({
//           client: "app",
//           query: Tag`query GetEvents($query: QEvents) {
//   events(query: $query) {
//     size
//     total
//    data {
//      id
//      oid
//      first
//      last
//      lvalue
//
//      recover
//       status
//       cuid
//       o_cuser{ name}
//       ctime
//       cphoto
//       conclusion
//       comment
//       oid
//
//       o_puser {
//         name
//       }
//
//      result
//       ptime
//       pphoto
//       pmark
//       status
//       o_ticket { id }
//
//      o_alarm_sensor {
//        o_alarm {
//          name
//          type
//          low
//          high
//        }
//        o_source {
//          name
//          unit
//        }
//        o_station {
//           id
//           name
//           type
//           addr
//           position
//           o_area{ name }
//        }
//      }
//    }
//   }
// }`,
//           variables: {
//             query: {
//               page: 1,
//               limit: 999,
//               count: true,
//               recover: 0,
//               state: "open",
//               alarms: null,
//               levels: null,
//               orders: ["-e.first"],
//               areas: null,
//               stypes: this.stypes,
//               viptype: null,
//               wtype: null,
//               categories: [],
//             },
//           },
//         })
//         .then((rep) => {
//       this.events = rep.data.events.data
rep[0].first = new Date()/1000;
rep[0].last = new Date()/1000;
          this.events = JSON.parse(JSON.stringify(rep))
            .filter((i) => i.o_alarm_sensor.o_station.name)
            .map((item) => {
              return {
                ...item,
                duration:
                  parseInt((new Date() / 1000 - item.first) / 3600).toFixed(1) +
                  " 小时",
                value:
                  item.lvalue && (item.o_alarm_sensor.o_source || {}).unit
                    ? getValueUnit(
                        item.lvalue,
                        item.o_alarm_sensor.o_source.unit
                      )
                    : "0.1",
              };
            });
          this.total = this.events.length;
          this.notices = this.events.map((item) => {
            let type1Div = ``;
            if (item.o_alarm_sensor.o_alarm.type == 1) {
              //限值报警 加箭头
              if (item.o_alarm_sensor.o_alarm.low > item.lvalue) {
                type1Div = `<span style="color: #22ff47">⬇</span> `;
              } else if (item.o_alarm_sensor.o_alarm.high < item.lvalue) {
                type1Div = `<span style="color: red">⬆</span>  `;
              }
            }
            return `<b style="color: #f8b959">${item.last?new Date(
              item.last * 1000
            ).Format("MM-DD hh:mm"):'-'}</b><strong class="event"  style="color: red"><span style="color: red"> ${
              item.o_alarm_sensor.o_station.name
            }管道${item.o_alarm_sensor.o_alarm.name}</span>${
              item.lvalue
                ? "，报警值：" +
                  getValueUnit(
                    item.lvalue,
                    item.o_alarm_sensor.o_source.unit
                  )
                : "，报警值：0.1"
            }</strong>${type1Div}`;
          });
          if (!this.timer2 && this.events.length > 1) {
            this.timer2 = setInterval(this.noticeLoop, 3000);
          }
          this.$nextTick(() => {
            this.initVoice();
          });
        // });
    },
    noticeLoop() {
      this.animate = true;
      setTimeout(() => {
        this.notices.push(this.notices[0]);
        this.notices.shift();
        this.animate = false;
      }, 500);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer2);
  },
  mounted() {
    // this.stypes = ["factory"];
    this.$nextTick(()=>{
      this.init();
    })
    // this.timer = setInterval(() => {
    //   // this.stypes = ["factory", "dma"];
    //   this.init();
    // }, 30000);
  },
};
</script>

<style  lang="less">

.alert {
  height: 55px;
  padding-left: 0px;
  display: flex;
  align-items: center;
  pointer-events: auto;
  //width: 500px;
  @keyframes blink {
    0%, 100% { opacity: 1; } /* 完全不透明 */
    //20%, 80% { opacity: 1; } /* 完全不透明 */
    50% { opacity: 0.5; }      /* 半透明 */
  }
  .event{
    animation: blink 2s infinite;

  }

  img{
    width: 24px;
    height: 24px;

  }

  &-content {
    margin-left: 0px;
    font-size: 15px;
    width: 1000px;

    &-detail {
      text-align: left;
      //&:hover {
      //  cursor: pointer;
      //  text-decoration: #ccc underline;
      //}
    }
  }
  &-block {
    display: flex;
    position: relative;
    height: 15px;
    line-height: 15px;
    flex: 1;
    overflow: hidden;
    cursor: pointer;
    color: #fff;
    width: 100%;
    ul {
      position: absolute;
      width: 100%;
      margin-top: 0;
      margin-left: 0;
      padding-left: 10px;
      li {
        width: 100%;
        list-style: none;
        height: 15px;
        text-align: left;
        overflow-x: hidden;
      }

      &.margin-top {
        margin-top: -15px;
        transition: all 0.5s;
      }
    }
  }

  .c-notice {
    width: 100%;
    z-index: 100;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    height: 100%;
    overflow-y: auto;

    table {
      width: 100%;
      border-collapse: collapse;
      overflow: hidden;
      //table-layout: fixed;

      td {
        border-bottom: 1px solid #ddd;
        //padding: 5px;
        white-space: normal;
        line-height: 50px;
      }
      .name {
        font-weight: bold;
      }
    }

    &--create,
    &--trigger {
      background-color: #f90;
    }

    &--update {
      background-color: #2d8cf0;
    }

    &--recover {
      background-color: #19be6b;
    }

    &__header {
      ::v-deep .ivu-tabs-bar {
        margin-bottom: 0;
      }
    }

    &__content {
      position: relative;
      padding: 5px 10px;
      flex: 1;
      overflow: hidden;
    }
  }
}
</style>
